import { useEffect, useRef } from "react";
import {
    hasSeenBlogTour,
    isBlogTourResume,
    startComposeTour,
    startFeedTour,
} from "./blogWalkthrough.js";

export const useBlogWalkthrough = (page, { ready = true, onWrite } = {}) => {
    const onWriteRef = useRef(onWrite);
    onWriteRef.current = onWrite;

    useEffect(() => {
        if (!ready) return;
        if (hasSeenBlogTour(page) && !isBlogTourResume(page)) return;
        const timer = window.setTimeout(() => {
            if (page === "feed") startFeedTour({ onWrite: () => onWriteRef.current?.() });
            if (page === "compose") startComposeTour();
        }, 500);
        return () => window.clearTimeout(timer);
    }, [page, ready]);
};
